import styled from 'styled-components';

export const ContentWrapperStyled = styled.div`
  position: relative;
  max-width: 109.6rem;
`;
